import React from "react";
import { Navigate } from "react-router-dom";

/**
 * @param {ReactNode} children - the component to render if authorized
 * @param {string[]} allowedRoles - array of roles allowed for this route
 */
function ProtectedRoute({ children, allowedRoles }) {
  const token = localStorage.getItem("token"); // JWT token
  const role = localStorage.getItem("role");   // role saved at login

  // If not logged in → redirect to login
  if (!token) return <Navigate to="/" replace />;

  // If role is not allowed → redirect to login (or 403 page)
  if (allowedRoles && !allowedRoles.includes(role)) return <Navigate to="/" replace />;

  // Authorized → render children
  return children;
}

export default ProtectedRoute;
